import * as React from 'react'
import './product-list.css'
import { Link } from 'react-router-dom'
import icelandicReplace from 'src/components/Shared/Icelandic'

export default class ProductList extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    const content = this.props.content
    return (
      <div className="item-container product-list-overview">
        <button className="category-header">Yfirflokkar</button>
        <div className="product-list-container">
          {content !== undefined &&
            Object.keys(content).map(key => {
              // const itemClassName =

              const image = {
                backgroundImage: `url(${content[key].fields.icon.fields?.file?.url})`,
              }
              const correctClassName =
                parseInt(key + 1, 10) % 3 !== 0 || key === '0'
                  ? 'product-list-item items-3 item-gutter'
                  : 'product-list-item items-3'
              const correctUrl =
                '/vorur/' + icelandicReplace(content[key].fields.title)

              return (
                <Link to={correctUrl} key={key} className={correctClassName}>
                  <div className="product-list-image" style={image} />
                  <div className="product-item-text">
                    <span>{content[key].fields.title}</span>
                  </div>
                </Link>
              )
            })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Product-page/product-list/product-list.tsx